import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { NgxsStateFacade } from '../../shared/store/ngxs-state-facade';
import { PaymentService } from '../services/payment.service';

export interface PaymentStateModel {
  amount: number;
}

export class StartPayment {
  static readonly type = '[Payment] Start Payment';
  constructor(public amount: number) {}
}

@State<PaymentStateModel>({
  name: 'payment',
  defaults: {
    amount: 0,
  },
})
@Injectable()
export class PaymentState extends NgxsStateFacade<PaymentStateModel> {
  constructor(
    store: Store,
    private readonly paymentSvc: PaymentService,
  ) {
    super(store, 'payment');
  }

  @Selector()
  static amount(state: PaymentStateModel): number {
    return state.amount;
  }

  // --- Public API ---

  startPayment(amount: number): void {
    this.store.dispatch(new StartPayment(amount));
  }

  // --- Actions ---

  @Action(StartPayment)
  startPaymentHandler(ctx: StateContext<PaymentStateModel>, action: StartPayment) {
    this.paymentSvc.addPayment(action.amount);
  }
}
